<template>
	<div>
		<div class="table-box" ref="scroll" >
			<!-- 表头 -->
			<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
				
				<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
					<template v-for="(item,index) in rableTitle" name="item.type">
						<div v-if="index <= sticky_index && item.show_control" class="table-th-cell" style="cursor: default;"
						:style="{'width':rableTitle[index].width + 'px','cursor':item.sort_control?'pointer':'default',}" 
						@click="sortClick(index)">
							{{rableTitle[index].title}}
							<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
								<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
								<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
							</div>
						</div>
					</template>
				</div>
				<div v-for="(item,index) in rableTitle" :key="index" >
					<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
					:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
					@click="sortClick(index)">
						{{item.title}}
						<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
							<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
							<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
						</div>
					</div>
				</div>
				
				<!-- 天维度 -->
				<div v-if='day_week_control === "daily"' style="display:flex;align-items: center;">
					<div  v-for="(item,index) in show_day_control" :key="index" >
						<div class="table-th-cell" 
						:style="{'width':day_week_width + 'px'}" >
							D{{index+1}}
						</div>
					</div>
				</div>
				
				<!-- 周维度 -->
				<div v-else style="display:flex;align-items: center;">
					<div  v-for="(item,index) in 8" :key="index" >
						<div class="table-th-cell" 
						:style="{'width':day_week_width + 'px'}" >
							W{{index+1}}
						</div>
					</div>
				</div>
				
				<!-- 占位，隔出一个空白区域 -->
				<div id="" style="width:30px;height: 46px;background-color: #fbfbfb;border-bottom: 1px solid #e8e8e8;">  </div>
			</div>
			
			<!-- 总计 -->
			<div  v-if="Object.keys(tableTotalData).length > 0">
				<div class="table-td" :style="{'width': table_scroll_width + 'px'}">
					<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
						<template v-for="(z_tem,z_ndex) in rableTitle">
							<div v-if="z_ndex <= sticky_index && z_ndex == 0" class="table-td-cell"
							:style="{'width':rableTitle[z_ndex].width + 'px'}">
								所有页总计
							</div>
							
							<div v-else-if="z_ndex <= sticky_index && z_tem.type == 'put_money'" class="table-td-cell"
							:style="{'width':rableTitle[z_ndex].width + 'px'}">
								<div style="color: #3085d6;word-wrap: break-word;">总金额：{{tableTotalData.put_money}}</div>
								<div style="color: #3085d6;word-wrap: break-word;">净金额：{{tableTotalData.used_money | tableToFixed}}</div>
							</div>
							
							<div v-else-if="z_ndex <= sticky_index " class="table-td-cell"
							:style="{'width':rableTitle[z_ndex].width + 'px'}">
								
							</div>
						</template>
						
					</div>
					<template v-for="(z_tem,z_ndex) in rableTitle">
						<!-- 回本状态 -->
						<div v-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'return_all_daily'" class="table-td-cell"
						 :class="{'text-right': rableTitle[z_ndex].text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}" style="font-size:12px;">
							<div class="db-true" v-if="tableTotalData.return_all_roi >= 100">已回本</div>
							<div class="db-false" v-else>未回本</div>
							
							<div>用时{{ tableTotalData.return_all_daily || 0 }}天</div>
							<div>回本充值金额：{{ tableTotalData.return_charge_money | tableToFixed }}</div>
							<div>回本分成金额：{{ tableTotalData.return_left_money | tableToFixed }}</div>
							<div>回本ROI：{{ tableTotalData.return_all_roi || 0 }}%</div>
							
						</div>
						<!-- 总充值统计 -->
						<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'charge_money'" class="table-td-cell"
						 :class="{'text-right': rableTitle[z_ndex].text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							<!-- 充值：{{tableTotalData.per}}% -->
							<!-- 充值金额 -->
							<div>{{tableTotalData.charge_money | tableToFixed}}</div>
							<!-- 充值人数 -->
							<div>{{tableTotalData.pay_user_num}}人</div>
							<!-- 充值用户成本 -->
							<div>充值用户成本：{{tableTotalData.vip_cost}}元</div>
						</div>
						<!-- 总分成统计 -->
						<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'earn_money'" class="table-td-cell"
						 :class="{'text-right': rableTitle[z_ndex].text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							<div>{{tableTotalData.left_money | tableToFixed}}</div>
							<div>利润：{{tableTotalData.earn_money}}</div>
							<div>ROI：{{tableTotalData.per}}%</div>
						</div>
						<!-- 复充统计 -->
						<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'pay_count_info'" class="table-td-cell"
						 :class="{'text-right': rableTitle[z_ndex].text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}"
						 style="font-size: 12px;display: flex;flex-wrap: wrap;justify-content: initial;flex-direction: initial;">
							<!-- 这里循环的是一个对象，value是值，key是键名 -->
							<div v-for="(value,key) in tableTotalData.pay_count_info" style="margin-right: 7px;margin-bottom: 5px;">{{key}}次:{{value}}人</div>
						</div>
						<!-- 当天新增用户数 -->
						<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'today_pay_user_num'" class="table-td-cell"
						 :class="{'text-right': rableTitle[z_ndex].text_right}"
						:style="{'width':rableTitle[z_ndex].width + 'px'}"
						>
							{{tableTotalData.sub_num}}
							
							<div>成本：{{tableTotalData.today_fans_cost}}</div>
						</div>
					</template>
					
					<!-- 天维度 -->
					<div v-if='day_week_control === "daily"' style="display:flex;align-items: center;">
						<div  v-for="(item_z,index) in tableTotalData.table_day" :key="index" >
							<div v-if="item_z.show_type_control" class="table-td-cell" 
							:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
							
								<div v-if="item_z.show_value.charge_money">充值金额：{{item_z.show_value.charge_money | tableToFixed}}</div>
								<div v-if="item_z.show_value.money">分成金额：{{item_z.show_value.money | tableToFixed}}</div>
								<div v-if="item_z.show_value.incr">新增ROI：{{item_z.show_value.incr || 0}}%</div>
								<div v-if="item_z.show_value.total_return">总ROI：{{item_z.show_value.total_return | tableToFixed}}%</div>
								<div v-if="item_z.show_value.charge_num">充值UV：{{item_z.show_value.charge_num}}</div>
								<template v-if="index == 0">
									<!-- <div v-if="tableTotal.Data.used_money && !item_z.show_value.charge_num">成本：{{tableTotalData.used_money || 0}}</div> -->
									<div v-if="tableTotalData.used_money && item_z.show_value.charge_num">成本：{{Number(tableTotalData.used_money)/Number(item_z.show_value.charge_num) | tableToFixed}}</div>
									<!-- <div v-else-if="!tableTotalData.used_money && item_z.show_value.charge_num">成本：{{Number(item_z.show_value.charge_num) || 0}}</div> -->
									<!-- <div v-else></div> -->
									
									<div v-if="tableTotalData.today_arpu">ARPU：{{tableTotalData.today_arpu}}元</div>
								</template>
								
							</div>
							
						</div>
					</div>
					
					<!-- 周维度 -->
					<div v-else style="display:flex;align-items: center;">
						<div  v-for="(item_z,index) in tableTotalData.table_day" :key="index" >
							<div v-if="item_z.show_type_control" class="table-td-cell" 
							:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
								
								<div v-if="item_z.show_value.charge_money">充值金额：{{item_z.show_value.charge_money}}</div>
								<div v-if="item_z.show_value.money">分成金额：{{item_z.show_value.money}}</div>
								<div v-if="item_z.show_value.incr">新增ROI：{{item_z.show_value.incr || 0}}%</div>
								<div v-if="item_z.show_value.total_return">总ROI：{{item_z.show_value.total_return || 0}}%</div>
								<div v-if="item_z.show_value.charge_num">充值UV：{{item_z.show_value.charge_num}}</div>
								<template v-if="index == 0">
									<!-- <div v-if="tableTotalData.used_money && !item_z.show_value.charge_num">充值UV：{{tableTotalData.used_money || 0}}</div> -->
									<div v-if="tableTotalData.used_money && item_z.show_value.charge_num">成本：{{Number(tableTotalData.used_money)/Number(item_z.show_value.charge_num) | tableToFixed}}</div>
									<!-- <div v-else-if="!tableTotalData.used_money && item_z.show_value.charge_num">充值UV：{{Number(item_z.show_value.charge_num) || 0}}</div> -->
									<!-- <div v-else></div> -->
									<div v-if="tableTotalData.today_arpu">ARPU：{{tableTotalData.today_arpu}}元</div>
								</template>
							</div>
							
						</div>
					</div>
				</div>
				
			</div>
			
			
			<!-- 表格内容 -->
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<!-- 固定列部分 -->
				<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
					<template v-for="(z_tem,z_ndex) in rableTitle">
						<div v-if="z_ndex <= sticky_index && z_tem.show_control && z_tem.type != 'op_name' && z_tem.type != 'put_book' && z_tem.type != 'media_name' && z_tem.type != 'put_money'" class="table-td-cell"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							{{item[z_tem.type]}}
						</div>
						<!-- 推广信息 -->
						<div v-else-if="z_ndex <= sticky_index && z_tem.show_control && z_tem.type == 'op_name'" class="table-td-cell"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							<!-- 公众号 -->
							<div style="margin-top: 5px;color: #ea5455;word-wrap: break-word;">{{item.gzh_name}}</div>
							<!-- 书城渠道 -->
							<div style="margin-top: 5px;color: #ff8acc;word-wrap: break-word;">{{item.channel_name}}</div>
							<!-- 投手 -->
							<div style="margin-top: 5px;color: #62a8ea;word-wrap: break-word;">{{item.op_name}}</div>
						</div>
						<!-- 推广作品 -->
						<div v-else-if="z_ndex <= sticky_index && z_tem.show_control && z_tem.type == 'put_book'" class="table-td-cell"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							<!-- 投放小说 -->
							<div style="color: #3085d6;">
								{{item.put_book}}
							</div>
							<div class="edit_" @click="editClick('书籍选择', index, item.put_book)">编辑</div>
							
							<div v-if="item.book_return_require > 0" style="color: #aaa;margin-top: 5px;">首日Roi：{{item.book_return_require}}%</div>
							<div v-else style="color: #aaa;margin-top: 5px;">首日Roi：未设置</div>
							
							<div style="margin-top: 5px;">作品分类：{{item.put_book_category || '无'}}</div>
						</div>
						<!-- 推广媒体 -->
						<div v-else-if="z_ndex <= sticky_index && z_tem.show_control && z_tem.type == 'media_name'" class="table-td-cell"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							<div style="color: #3085d6;">{{item.media_name}}</div>
							<div @click="editClick('投放渠道', index, item.media_name)" class="edit_">编辑</div>
						</div>
						<!-- 投放金额 -->
						<div v-else-if="z_ndex <= sticky_index && z_tem.show_control && z_tem.type == 'put_money'" class="table-td-cell"
						:style="{'width':rableTitle[z_ndex].width + 'px'}">
							<div style="color: #3085d6;word-wrap: break-word;margin-bottom: 3px;">总金额：{{item.put_money}}</div>
							<div class="edit_" @click="editClick('投放金额', index, item.put_money)">编辑</div>
							<div v-if="item.put_money" style="color: #3085d6;word-wrap: break-word;">净金额：{{item.used_money}}</div>
						</div>
					</template>
				</div>
				
				<!-- 非固定列部分 -->
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<!-- 回本状态 -->
					<div v-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'return_all_daily'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}" style="font-size: 12px;">
						<div class="db-true" v-if="item.return_all_roi >= 100">已回本</div>
						<div class="db-false" v-else>未回本</div>
						
						<div>用时{{item.return_all_daily || 0}}天</div>
						<div>回本充值金额：{{item.return_charge_money || 0}}</div>
						<div>回本分成金额：{{item.return_left_money || 0}}</div>
						<div>回本ROI：{{item.return_all_roi || 0}}%</div>
						
					</div>
					<!-- 总充值统计 -->
					<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'charge_money'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						<!-- 充值金额 -->
						<div>{{item.charge_money | tableToFixed}}</div>
						<!-- 充值人数 -->
						<div>{{item.pay_user_num}}人</div>
						<!-- 充值用户成本 -->
						<div>充值用户成本：{{item.vip_cost}}元</div>
						
					</div>
					<!-- 总分成统计 -->
					<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'earn_money'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}" style="font-size: 12px;">
						<div>{{item.left_money}}</div>
						<div>利润：{{item.earn_money}}</div>
						<div>ROI：{{item.per}}%</div>
					</div>
					<!-- 复充统计 -->
					<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'pay_count_info'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}" style="font-size: 12px;display: flex;flex-wrap: wrap;justify-content: initial;flex-direction: initial;">
						<!-- 这里循环的是一个对象，value是值，key是键名 -->
						<div v-for="(value,key) in item.pay_count_info" style="margin-right: 7px;margin-bottom: 5px;">{{key}}次:{{value}}人</div>
					</div>
					<!-- 当天新增用户数 -->
					<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'today_pay_user_num'" class="table-td-cell"
					 :class="{'text-right': rableTitle[z_ndex].text_right}"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						<div style="color: #3085d6;">{{item.sub_num}}人</div>
						<div class="edit_" @click="editClick('新增粉丝', index, item.sub_num)">编辑</div>
						
						<div style="margin-top: 5px;">成本：{{item.today_fans_cost}}</div>
					</div>
				</template>
				
				<!-- 天维度 -->
				<div v-if='day_week_control === "daily"' style="display:flex;align-items: center;">
					<div  v-for="(item_z,index) in item.table_day" :key="index" >
						<div class="table-td-cell" :style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
							<div v-if="item_z.show_value.charge_money">充值金额：{{item_z.show_value.charge_money}}</div>
							<div v-if="item_z.show_value.money">分成金额：{{item_z.show_value.money}}</div>
							<div v-if="item_z.show_value.incr">新增ROI：{{item_z.show_value.incr || 0}}%</div>
							<div v-if="item_z.show_value.total_return">总ROI：{{item_z.show_value.total_return || 0}}%</div>
							<div v-if="item_z.show_value.charge_num">充值UV：{{item_z.show_value.charge_num}}</div>
							
							<template v-if="index == 0">
								<!-- <div v-if="item.used_money && !item_z.show_value.charge_num">成本：{{item.used_money || 0}}</div> -->
								<div v-if="item.used_money && item_z.show_value.charge_num">成本：{{Number(item.used_money)/Number(item_z.show_value.charge_num) | tableToFixed}}</div>
								<!-- <div v-else-if="!item.used_money && item_z.show_value.charge_num">成本：{{Number(item_z.show_value.charge_num) || 0}}</div> -->
								<!-- <div v-else></div> -->
								<div v-if="item.today_arpu">ARPU：{{item.today_arpu}}元</div>
							</template>
							
							<div class="db-true" v-if="item_z.db == '1'">达标</div>
							<div class="db-false" v-else-if="item_z.db == '2'">未达标</div>
						</div>
					</div>
				</div>
				
				<!-- 周维度 -->
				<div v-else style="display:flex;align-items: center;">
					<div  v-for="(item_z,index) in item.table_day" :key="index" >
						<div class="table-td-cell" 
						:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
							<div v-if="item_z.show_value.charge_money">充值金额：{{item_z.show_value.charge_money}}</div>
							<div v-if="item_z.show_value.money">分成金额：{{item_z.show_value.money}}</div>
							<div v-if="item_z.show_value.incr">新增ROI：{{item_z.show_value.incr || 0}}%</div>
							<div v-if="item_z.show_value.total_return">总ROI：{{item_z.show_value.total_return || 0}}%</div>
							<div v-if="item_z.show_value.charge_num">充值UV：{{item_z.show_value.charge_num}}</div>
							<template v-if="index == 0">
								<!-- <div v-if="item.used_money && !item_z.show_value.charge_num">充值UV：{{item.used_money || 0}}</div> -->
								<div v-if="item.used_money && item_z.show_value.charge_num">成本：{{Number(item.used_money)/Number(item_z.show_value.charge_num) | tableToFixed}}</div>
								<!-- <div v-else-if="!item.used_money && item_z.show_value.charge_num">充值UV：{{Number(item_z.show_value.charge_num) || 0}}</div> -->
								<!-- <div v-else></div> -->
								
								<div v-if="item.today_arpu">ARPU：{{item.today_arpu}}元</div>
							</template>
						</div>
						<!-- <div v-else class="table-td-cell"
						:style="{'width':day_week_width + 'px'}" style="font-size: 12px;">
							<div style="word-wrap: break-word;color: #62a8ea;">充值：0</div>
						</div> -->
						
					</div>
				</div>
				
			</div>
			
			
			
			<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: rgb(240, 242, 245);height: calc(100vh - 65px);width: 20px;"></div>
			<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: rgb(240, 242, 245);height: calc(100vh - 65px);width: 20px;"></div>
			
			
		</div>
		
		
	</div>
</template>

<script>
import { effectUpdate } from '@/request/api'
export default {
	name: 'TableEffectB_',
	props: ['rableTitle','tableShowData','tableTotalData','table_scroll_width','date_type_control','show_day_control','day_week_control',"day_week_width"],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
			media_name_focus: false, // 焦点
			
			
			edit_modal_title: "", // 编辑弹窗的标题
			// 编辑弹窗的内容
			m_put_money: "", // 投放金额
			
			sticky_index: 5,
		}
	},
	methods: {
		// 编辑按钮
		editClick(title,index,value){
			// console.log(11111111111)
			// this.edit_modal_title = "编辑" + title
			// this.visible = true;
			
			this.$emit('edit-table-cell', title, index, value)
		},
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index])
			if(!that.rableTitle[index].sort_control){
				return
			}
			if(index !== this.select_sort_index){
				this.select_sort_index = index
				that.rableTitle.forEach(res=>{
					res.sort_status = 0
				})
				that.rableTitle[index].sort_status = 1
				th_status = 1
			}
			else { // 点击的是同一个表头
				if(that.rableTitle[index].sort_status === 0){
					that.rableTitle[index].sort_status = 1 // 箭头向下
					th_status = 1
				}
				else if(that.rableTitle[index].sort_status === 1){
					that.rableTitle[index].sort_status = 2 // 箭头向上
					th_status = 2
				}
				else if(that.rableTitle[index].sort_status === 2){
					that.rableTitle[index].sort_status = 0
					th_status = 0
				}
			}
			
			let r_type
			if(that.rableTitle[index].type === 'date_key'){ // 推广日期
				r_type = 'date_key'
			}
			else if(that.rableTitle[index].type === "put_money"){ // 投放金额
				r_type = 'put_money'
			}
			else if(that.rableTitle[index].type === "charge_money"){ // 总充值统计
				r_type = 'total_charge_money'
			}
			// else {
			// 	r_type = that.rableTitle[index].type
			// }
			
			this.$emit('table-th-click', index, th_status, r_type)
		}
	},
	filters: {
		tableToFixed(value){
			// console.log("过滤器",value)
			let ttt 
			if(Number(value)){
				
				ttt = Number(value).toFixed(2) // 不转化成数字类型的数据的话，遇到字符串的值就会报错
			}
			else {
				ttt = 0
			}
			return ttt
		}
	}
}
</script>

<style scoped>
.table-box {
	position: relative;
	width: 100%;
	overflow-x: visible;
}

/* .table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
} */

.db-true,
.db-false {
	width: 50px;
	margin-top: 5px;
	text-align: center;
	border-radius: 3px;
	color: #fff;
}
.db-true {
	background-color: #20c997;
}
.db-false {
	background-color: #ea5455;
}

.edit_ {
	display: none;
	height: 20px;
	color: #62a8ea;
	cursor: pointer;
}
.table-td-cell:hover .edit_ {
	display: block;
}

.table-th-cell:hover {
		background-color: #eee;
	}
	.table-th-cell:hover .table-th-cell-sticky{
		background-color: #eee;
	}
/* 使用flex来使表格粘性布局内容占满高度 */
.table-td {
	align-items: initial;
	
	background: #fff;
}
.table-td:hover {
	/* background-color: #eff9ff; */
	background-color: #fafafa;
}
.table-td-cell-sticky {
	display: flex;
	align-items: center;
	
	left: 20px;
}
.table-td-cell {
	display: flex;
	align-items: flex-start;
	font-size: 12px;
	flex-direction: column;
	justify-content: center;
}

.table-th-cell-sticky {
	left: 20px;
}
</style>